module.exports = __webpack_public_path__ + "img/hall-stat-background@1.5x.e099dac0.png";